module.exports = __webpack_public_path__ + "static/media/home1.d0184a59.svg";